/*   Copyright (c) 2020
 *   All rights reserved.
 *   Distribution Statement B. Distribution authorized to U.S.
 *    Government agencies only.PavCon, LLC Proprietary.All rights reserved.
 *   2020 WARNING: this file may contain export controlled information.
 */

import { IAppResponse } from '../interceptors/response-interceptor';
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { HttpHelperService } from './http-helper.service';

interface usernameRequest {
  username: string;
}

interface emailRequest {
  email: string;
}

interface passwordHashRequest {
  passwordHash: string;
  cognitoSub: string;
}
@Injectable({
  providedIn: 'root'
})
export class SignUpFormValidationService {
  private baseUrl = `${environment.endpoint}auth`;

  constructor(private httpHelperService: HttpHelperService) {}

  async verifyEmail(data: emailRequest): Promise<IAppResponse> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/checkEmail`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async verifyUsername(data: usernameRequest): Promise<IAppResponse> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/checkUsername`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async storeHash(data: passwordHashRequest): Promise<IAppResponse> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/hashStore`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async checkDisabled(data: usernameRequest): Promise<IAppResponse> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/disabledCheck`,
        data
      );
    } catch (error) {
      throw error;
    }
  }
}
/* Distribution Statement B. Distribution authorized to U.S.
Government agencies only.PavCon, LLC Proprietary.All rights reserved.
2020 WARNING: this file may contain export controlled information.
 */
